module.exports = __webpack_public_path__ + "914210c79b1a6f434a16cd56a5a4f451.svg";